import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/home/login'
import home from '@/pages/home/index'
import GoodsShow from '@/pages/goods/goods_show'
import GoodsList from '@/pages/goods/goods_list'
import NewActivityGoods from '@/pages/activity/new_activity_goods'
import SpecialActivityGoods from '@/pages/activity/special_activity_goods'
import ZoneActivityGoods from '@/pages/activity/zone_activity_goods'
import PointsGoods from '@/pages/points/points_goods'
import RecommendGoods from '@/pages/activity/recommend_goods'
import NewsList from '@/pages/news/news_list'
import CartList from '@/pages/cart/cart_list'
import OrderSubmit from '@/pages/cart/order_submit'
import OrderList from '@/pages/order/order_list'
import OrderShow from '@/pages/order/order_show'
import ReturnOrderList from '@/pages/order/return_order_list'
import ReturnOrderShow from '@/pages/order/return_order_show'
import StoreInfo from '@/pages/store/store_info'
import Collect from '@/pages/store/collect'
import Browse from '@/pages/store/browse'
import Integral from '@/pages/store/integral'
import Coupons from '@/pages/store/coupons'
import CustomerService from '@/pages/store/customer_service'
import Evaluate from '@/pages/store/evaluate'
import Feedback from '@/pages/store/feedback'
import ActivityShow from '@/pages/activity/activity_show'
import LogisticsInfo from '@/pages/order/logistics_info'
import SalesReturn from '@/pages/order/sales_return'
import OrderEvaluate from '@/pages/order/order_evaluate'
import SearchList from '@/pages/goods/search_list'
import Help from '@/pages/store/help'
import Password from '@/pages/store/password'
import Register from '@/pages/store/register'
import Message from '@/pages/store/message'
import VipInfo from '@/pages/store/vip_info'
import StoreBill from '@/pages/store/store_bill'
import PayOrder from '@/pages/cart/pay_order'
import CheckUser from '@/pages/public/check_user'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/goods/goods_show',
    name: 'goods_show',
    component: GoodsShow,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/goods/goods_list',
    name: 'goods_list',
    component: GoodsList,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/activity/new_activity_goods',
    name: 'new_activity_goods',
    component: NewActivityGoods,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/activity/special_activity_goods',
    name: 'special_activity_goods',
    component: SpecialActivityGoods,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/points/points_goods',
    name: 'points_goods',
    component: PointsGoods,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/activity/zone_activity_goods',
    name: 'zone_activity_goods',
    component: ZoneActivityGoods,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/activity/recommend_goods',
    name: 'recommend_goods',
    component: RecommendGoods,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/news/news_list',
    name: 'news_list',
    component: NewsList,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/cart/cart_list',
    name: 'cart_list',
    component: CartList,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/cart/order_submit',
    name: 'order_submit',
    component: OrderSubmit,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/order/order_list',
    name: 'order_list',
    component: OrderList,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/order/order_show',
    name: 'order_show',
    component: OrderShow,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/order/return_order_list',
    name: 'return_order_list',
    component: ReturnOrderList,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/order/return_order_show',
    name: 'return_order_show',
    component: ReturnOrderShow,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/store/store_info',
    name: 'store_info',
    component: StoreInfo,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/collect',
    name: 'collect',
    component: Collect,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/browse',
    name: 'browse',
    component: Browse,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/integral',
    name: 'integral',
    component: Integral,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/store/coupons',
    name: 'coupons',
    component: Coupons,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/customer_service',
    name: 'customer_service',
    component: CustomerService,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/store/evaluate',
    name: 'evaluate',
    component: Evaluate,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/store/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/activity/activity_show',
    name: 'activity_show',
    component: ActivityShow,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/order/logistics_info',
    name: 'logistics_info',
    component: LogisticsInfo,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/order/sales_return',
    name: 'sales_return',
    component: SalesReturn,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/order/order_evaluate',
    name: 'order_evaluate',
    component: OrderEvaluate,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/goods/search_list',
    name: 'search_list',
    component: SearchList,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/help',
    name: 'help',
    component: Help,
    meta: {auth: true, keepAlive: true}
  },
  {
    path: '/store/password',
    name: 'password',
    component: Password,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/register',
    name: 'register',
    component: Register,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/message',
    name: 'message',
    component: Message,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/vip_info',
    name: 'vip_info',
    component: VipInfo,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/store/store_bill',
    name: 'store_bill',
    component: StoreBill,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/cart/pay_order',
    name: 'pay_order',
    component: PayOrder,
    meta: {auth: true, keepAlive: false}
  },
  {
    path: '/public/check_user',
    name: 'check_user',
    component: CheckUser,
    meta: {auth: true, keepAlive: false}
  }
]

const router = new Router({
  routes
})

// 这里设置路由拦截
router.beforeEach((to, from, next) => {
  if (to.meta.auth && to.fullPath !== '/store/password' && to.fullPath !== '/store/register' && to.fullPath !== '/public/check_user') {
    var token = localStorage.getItem('store_info')

    if (token) {
      var jsarr = JSON.parse(token)
      if (token && jsarr && jsarr.token) {
        next()
      } else {
        next({
          path: '/login'
        })
      }
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
}
)
export default router

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js